const DASHBOARD_WIDGET_CHART_SYNC_ID_PREFIX = "dashboard-widget"

export const CHART_SYNC_METHOD = "value"

export const getDashboardWidgetChartSyncId = (widgetId: string): string =>
  `${DASHBOARD_WIDGET_CHART_SYNC_ID_PREFIX}:${widgetId}`
